<script>
import Menu from 'ant-design-vue/es/menu';

export default {
  name: 'MMenuItem',
  extends: Menu.Item
};
</script>
